/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 25/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import { apiObtenerListaPreventas, apiObtenerListaCotizaciones } from "../../settings/ApiConfig"
import { useRequest } from "../../context/System/RequestContext";
import { useLayout } from "../../context/System/LayoutContext";

import React, { Fragment, useState, useEffect, useRef } from "react";

import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import SizeSoftXTablePaginadoFilter from "../../components/leyout/SizeSoftXTablePaginadoFilter"

import { Modal, Box, MenuItem, Typography, InputAdornment } from "@mui/material";
import _ from 'lodash';

// Estilos para el modal con efecto suavizado de desplazamiento
const modalStyle = {
    position: 'fixed',
    top: '6%',
    right: '5%',
    width: '90vw',
    height: '90vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateX(100%)', // Inicialmente fuera de la pantalla
    transition: 'transform 0.5s ease-in-out',
    borderRadius: '9px',
};

export default function ModalJalarPreventasCotizaciones(props) {
    const { openModalJalarPreventaCotizacion, handleCloseModalJalarPreventaCotizacion, handleJalarPreventaCotizacion, vendedor = "", modal} = props;

    const boxRef = useRef(null);
    const folioSeleccionadoRef = useRef({});
    const listaVentasRef = useRef([]);

    const { GetRequest, PostRequest } = useRequest()
    const { handleOpenAlert } = useLayout();
    
    const [modalVisible, setModalVisible] = useState(false);
    const [internalOpen, setInternalOpen] = useState(false);

    const [folioSeleccionado, setFolioSeleccionado] = useState({});
    const [tipoVenta, setTipoVenta] = useState(modal);
    const [listaVentas, setListaVentas] = useState([]);

    useEffect(() => {
        if (openModalJalarPreventaCotizacion) {
            setInternalOpen(true);
            setTimeout(() => {
                setModalVisible(true);
                if (boxRef.current) {
                    boxRef.current.scrollTop = 0;
                }
            }, 50);
            setTipoVenta(modal);
            handleBuscarVentas(modal);
        } else {
            setModalVisible(false);
            setTimeout(() => setInternalOpen(false), 500);
        }
    }, [openModalJalarPreventaCotizacion, modal]);

    const modalVisibleStyle = {
        transform: modalVisible ? 'translateX(0)' : 'translateX(100%)',
    };

    const resetearSeleccion = () => {
        folioSeleccionadoRef.current = {};
        setFolioSeleccionado({});
    };

    const handleBuscarVentas = async (tipo = tipoVenta) => {
        resetearSeleccion();
        setListaVentas([]);
        listaVentasRef.current = [];

        if (!tipo || tipo.trim() === "") {
            setTipoVenta(modal);
            return;
        }

        let url = "";
        if (tipo === "PREVENTA") url = apiObtenerListaPreventas;
        if (tipo === "COTIZACION") url = apiObtenerListaCotizaciones;
        if (!url) return;

        const response = await GetRequest({
            url,
            loader: "Buscando registros en sistema..."
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        const listaVentasConTipo = response?.result?.map((venta, index) => {
            const ventaLimpia = trimObjectStrings(venta);
            return {
                ...ventaLimpia,
                tipoventa: tipo === "PREVENTA" ? "PREVENTA" : "COTIZACIÓN",
                id: index + 1,
            };
        });

        setListaVentas(listaVentasConTipo);
        listaVentasRef.current = listaVentasConTipo || [];
    };

    const handleAccionarRegistroaVentas = async () => {
        const selected = folioSeleccionadoRef.current;

        if (!selected || Object.keys(selected).length === 0) {
            handleOpenAlert("Seleccione un registro de la lista primero", "warning");
            return;
        }

        await handleJalarPreventaCotizacion(selected);
        handleCloseModalJalarPreventaCotizacion();
    };

    const TiposVenta = [{id: 1, nombre:"PREVENTA"}, {id:2 , nombre: "COTIZACION"}];

    const handleChangeTipoVenta = (x) => {
        setTipoVenta(x);
    };
    
    const handleChangeFolioSeleccionada = async (x) =>{
        folioSeleccionadoRef.current = x;
        await setFolioSeleccionado(x);
    };

    const trimObjectStrings = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const value = obj[key];
            if (typeof value === "string") {
                newObj[key] = value.trim();
            } else {
                newObj[key] = value;
            }
        });
        return newObj;
    };

    const handleCerrarModal=()=>{
        setListaVentas([]);
        listaVentasRef.current = [];
        handleCloseModalJalarPreventaCotizacion();
    };

    const handleKeyDownModal = async(event) => {
        if (event.key === "Enter") {
            
            event.preventDefault();
            event.stopPropagation();
            handleAccionarRegistroaVentas();
        }

        if (event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            handleCerrarModal();
        }
    };
    
    const isTyping = (el) => {
        const tag = el?.tagName?.toLowerCase();
        return tag === "input" || tag === "textarea" || el?.isContentEditable;
    };

    useEffect(() => {
        if (!internalOpen) return;
        
        setTimeout(() => boxRef.current?.focus(), 100);

        const onKey = (e) => {

            if (isTyping(e.target) && (e.key === "ArrowDown" || e.key === "ArrowUp")) return;

            if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            handleCerrarModal();
            }

            if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            handleAccionarRegistroaVentas();
            }

            if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;

            e.preventDefault();
            e.stopPropagation();

            const list = listaVentasRef.current || [];
            if (!list.length) return;

            const current = folioSeleccionadoRef.current;
            const key = "id";
            
            let idx = list.findIndex((x) => x?.[key] === current?.[key]);
            if (idx === -1) idx = 0;

            const step = e.key === "ArrowDown" ? 1 : -1;
            let next = idx + step;

            // solo navega dentro de la lista completa (sin paginación)
            if (next < 0) next = 0;
            if (next >= list.length) next = list.length - 1;

            const nextRow = list[next];
            folioSeleccionadoRef.current = nextRow;
            setFolioSeleccionado(nextRow);
        };

        window.addEventListener("keydown", onKey, true);
        return () => window.removeEventListener("keydown", onKey, true);
    }, [internalOpen]); // ok porque handleAccionar ya lee del ref

    return (
        <Box ref={boxRef} onKeyDown={handleKeyDownModal} tabIndex={-1}>
            <Modal
                open={internalOpen}
                onClose={handleCerrarModal}
                aria-labelledby="menu-modal-title"
                aria-describedby="menu-modal-description"
                closeAfterTransition
                >
                <Box sx={{ ...modalStyle, ...modalVisibleStyle }}>
                    <Fragment>
                        <div className="containerJajarVentas">
                            <TextField autoComplete="off"
                                name="tipoventa"
                                label="Tipo venta:"
                                value={tipoVenta} 
                                onChange={(e) => handleChangeTipoVenta(e.target.value)}
                                onKeyDown={handleKeyDownModal}
                                sx={{ width: '240px' }}
                                select
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LocalGroceryStoreIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            >
                                <MenuItem value={0}>--Seleccionar--</MenuItem>
                                {TiposVenta.map((tipo) => (
                                    <MenuItem key={tipo} value={tipo.nombre}>
                                        {tipo.nombre}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>
                        <div className="containerlistaspreventas" style={{ flexGrow: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            <div className="tabla" style={{ height: '100%', minHeight: 0, overflow: 'hidden' }}>
                                <SizeSoftXTablePaginadoFilter
                                    columns={[
                                        { title: "Caja", field: "pc", align : "center", width: 150 },
                                        { title: "Origen", field: "almacenexhibidor", width: 220 },
                                        { title: "Prev. Vendedor", field: "vendedorpreventa" },
                                        { title: "Prev. Folio", field: "foliopreventa", align : "center" },
                                        { title: "Descripción", field: "descripcion" },
                                        { title: "Medida", field: "medida", align : "center" },
                                        { title: "Cantidad", field: "cantidad" , align : "center" },
                                        { title: "fecha/hora", field: "fecharegistro" },
                                        { title: "Tipo operación" , field: "tipoventa"},
                                    ]}
                                    data={listaVentas}
                                    totalDeRegistros={listaVentas.length}
                                    id="id"
                                    row={folioSeleccionado}
                                    setRow={handleChangeFolioSeleccionada}
                                    fontSize="11px"
                                    EspaciadorColumnas = {9}
                                    disablePagination
                                    maxHeight="100%"
                                />  
                            </div>
                        </div>
                        <div className="containerSubmit" style={{ flexShrink: 0, marginTop: 16, textAlign: 'center' }}>
                            <button className="jalarRegistrosButton" onClick={handleAccionarRegistroaVentas}>Jalar registro</button>
                        </div>
                    </Fragment>
                </Box>
            </Modal>
        </Box>
    );
}
